import { render } from "./SelectReq.vue?vue&type=template&id=30bd7022&ts=true"
import script from "./SelectReq.vue?vue&type=script&lang=ts"
export * from "./SelectReq.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__